import * as React from "react"
import {Form, Input} from "semantic-ui-react"
import {MapState} from "./BookingDetails"

interface ExtrasState {
  babySeatsForward: number
  babySeatsBackward: number
  boosterSeats: number
}

export function adjustExtras(state: ExtrasState): ExtrasState {
  return {
    babySeatsForward: clamp(state.babySeatsForward, 0, 3),
    babySeatsBackward: clamp(state.babySeatsBackward, 0, 3),
    boosterSeats: clamp(state.boosterSeats, 0, 3),
  }
}

function clamp(value: number, min: number, max: number): number {
  return value < min ? min : value > max ? max : value
}

interface Props {
  state: ExtrasState
  mapState: MapState<ExtrasState> | null
  disabled: boolean
}

export function ExtrasFields({
  mapState,
  state: {babySeatsForward, babySeatsBackward, boosterSeats},
  disabled,
}: Props) {
  const labelStyle: React.CSSProperties = {whiteSpace: "nowrap"}
  return (
    <Form.Group>
      <Form.Field width={8}>
        <label style={labelStyle}>Forward Facing Baby Seats</label>
        {!mapState ? (
          <div>{babySeatsForward}</div>
        ) : (
          <Form.Input
            disabled={disabled}
            type="number"
            pattern="\d*"
            placeholder="Max 3"
            min="0"
            max="3"
            step="1"
            value={babySeatsForward === 0 ? "" : babySeatsForward.toString()}
            onChange={(e, field) => {
              mapState((state) => ({...state, babySeatsForward: Number(field.value)}))
            }}
          />
        )}
      </Form.Field>
      <Form.Field width={8}>
        <label style={labelStyle}>Rear Facing Baby Seats</label>
        {!mapState ? (
          <div>{babySeatsBackward}</div>
        ) : (
          <Form.Input
            disabled={disabled}
            type="number"
            pattern="\d*"
            placeholder="Max 3"
            min="0"
            max="3"
            step="1"
            value={babySeatsBackward === 0 ? "" : babySeatsBackward.toString()}
            onChange={(e, field) => {
              mapState((state) => ({...state, babySeatsBackward: Number(field.value)}))
            }}
          />
        )}
      </Form.Field>
      <Form.Field width={8}>
        <label style={labelStyle}>Booster Seats</label>
        {!mapState ? (
          <div>{boosterSeats}</div>
        ) : (
          <Form.Input
            disabled={disabled}
            type="number"
            pattern="\d*"
            placeholder="Max 3"
            min="0"
            max="3"
            step="1"
            value={boosterSeats === 0 ? "" : boosterSeats.toString()}
            onChange={(e, field) => {
              mapState((state) => ({...state, boosterSeats: Number(field.value)}))
            }}
          />
        )}
      </Form.Field>
    </Form.Group>
  )
}

interface State {
  showBookingExtras: boolean
}

export class ExtrasFieldsWithButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showBookingExtras:
        props.state.babySeatsBackward !== 0 ||
        props.state.babySeatsForward !== 0 ||
        props.state.boosterSeats !== 0,
    }
  }

  render() {
    const {mapState, state, disabled} = this.props
    if (this.state.showBookingExtras) {
      return (
        <>
          <ExtrasFields mapState={mapState} disabled={disabled} state={state} />
        </>
      )
    } else if (this.props.mapState) {
      return (
        <>
          <Form.Button
            disabled={disabled}
            content="Baby and Booster Seats"
            icon="chevron right"
            labelPosition="right"
            onClick={(e) => {
              e.preventDefault()
              this.setState({showBookingExtras: true})
            }}
          />
        </>
      )
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ExtrasFields.tsx